/** The only communication type ACE writes: mute transactional communication. */
export type OrttoCommunicationType = 'stop_transaction_communication';

export const STOP_TRANSACTION_COMMUNICATION: OrttoCommunicationType =
  'stop_transaction_communication';

/** A record of `GET /ortto/v1/communications` (MV-3396). */
export interface OrttoCommunication {
  ID: string;
  CustomerID: string;
  Country: string;
  Type: OrttoCommunicationType | string;
  CreatedBy: string;
  CreatedAt: string;
}
